<template>
    <div class="output-total">
        <div class="total-head1">

        </div>
        <div class="total-echart">
            <div id="echart1" style="width:100%;height:100%;"></div>
        </div>
        <div class="total-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
            >
              <template slot="empty">
                <p>{{ dataText }}</p>
              </template>
              <el-table-column label="序号" width="150" center>
                <template slot-scope="scope">
                  <a style="padding-left: 1vw">{{ scope.row.index }}</a>
                </template>
              </el-table-column>
              <el-table-column label="计划月份">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计划产值">
                <template slot-scope="scope">
                  <span>{{ scope.row.idcard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实际产值">
                <template slot-scope="scope">
                  <span>{{ scope.row.idcard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="累计产值">
                <template slot-scope="scope">
                  <span>{{ scope.row.clockTime }}</span>
                </template>
              </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            listData:[],
            dataText:'数据加载中...',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.showEchart()
        this.dataText = '暂无数据'
    },
    methods:{

        //展示图标数据
        showEchart(){
            var obj = this.$echarts.init(document.getElementById('echart1'))
            obj.setOption({
                color: ['#45abf0','#45def0', '#61a0a8'],
                title: {
                    text: '',
                    subtext: '',
                    left: 'center'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                legend: {
                    data:['计划进度','实际进度',{name:'第一年',icon:'circle'},{name:'第二年',icon:'circle'},{name:'第三年',icon:'circle'}]
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} 万元'
                },
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        splitLine : {show : false},
                        data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月','','']
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        position: 'left'
                    }
                ],
                series:[
                    {
                        name:'计划进度',
                        type:'bar',
                        barWidth : 15,//柱图宽度
                        data:[320, 332, 301, 334, 390, 330, 320, 400, 450, 480, 500, 550]
                    },
                    {
                        name:'实际进度',
                        type:'bar',
                        barWidth : 15,//柱图宽度
                        data:[200, 400, 300, 350, 400, 300, 300, 250, 350, 500, 400, 500]
                    },
                    {
                        name:'产值进度',
                        type:'pie',
                        tooltip : {
                            trigger: 'item',
                            formatter: '{a} <br/>{b} : {c} ({d}%)'
                        },
                        zlevel:10,
                        center: ['85%','30%'],
                        radius : [0, "40%"],
                        itemStyle :　{
                            normal : {
                                labelLine : {
                                    length : 20
                                },
                                color: function (params) {
                                    var colorList = ['#70BFED','#F47E86', '#6E38A8']
                                    return colorList[params.dataIndex]
                                },
                            }
                        },
                        data:[
                            {value:1048, name:'第一年',id:'2018'},
                            {value:1500, name:'第二年',id:'2019'},
                            {value:1800, name:'第三年',id:'2020'},
                        ]
                    }
                ]
            })
            obj.on('click',this.echartFun)
        },
        //扇形点击方法
        echartFun(param){
            
            if(param.seriesType=='pie'){
                console.log(param)
            }
        },
    }
}
</script>

<style scoped>
    .output-total{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .total-head1{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 0 1vw;
        justify-content: flex-start
    }
    .total-echart{
        width: 100%;
        height: calc( 50% - 1.5vh );
        position: relative;
        background: #fff;
        padding-top: 1vh;
    }
    .total-table{
        width: 100%;
        height: calc( 50% - 1vh );
        position: relative;
        background: #fff;
        margin-top: 0.5vh;
    }
</style>
<style>
    @import '../../../assets/css/common.css';
</style>